import Swiper from 'swiper'
import { Navigation, Autoplay } from 'swiper/modules'

Swiper.use([Navigation, Autoplay])

export const HotelClubPlusCTASlider = () => {
  const $slider = $('.js-hotelClubCta');

  if (!$slider.length) {
    return;
  }

 $(document).ready(function() {
   console.log('Hotel cta inita', $slider)
   new Swiper('.js-hotelClubCta', {
     effect: 'slide',
     autoplay: {
       delay: 3600,
       disableOnInteraction: true,
     },
     loop: true,
     initialSlide: 1,
     slidesPerView: 2,
     centeredSlides: true,
     speed: 600,
     navigation: {
       nextEl: '.c-hotelClubCta__next',
       prevEl: '.c-hotelClubCta__prev',
     },
   });
 });
}
